<template>
  <div class="content">
    <Header :title="'佣金规则'" />
    <div class="rule-wrap">
      <div class="tab-head">
        <input
          type="button"
          class="btnFranchisee"
          :class="[tabIndex === 0 ? 'active' : '']"
          value="加盟商"
          @click="tabIndex = 0"
        >
        <input
          type="button"
          class="btnSalesman"
          :class="[tabIndex === 1 ? 'active' : '']"
          value="业务员"
          @click="tabIndex = 1"
        >
      </div>
      <div class="tab-body">
        <div v-show="tabIndex === 0" class="tab">
          <div class="tab-frame">
            <!-- <h4 class="title">{{alliance.title}}</h4> -->
            <div class="txt" v-html="alliance.content" />
          </div>
        </div>
        <div v-show="tabIndex === 1" class="tab">
          <div class="tab-frame">
            <!-- <h4 class="title">{{salesMan.title}}</h4> -->
            <div class="txt" v-html="salesMan.content" />
          </div>
        </div>
      </div>
      <div class="img-wrap-bottom">
        <img src="@/assets/images/rule-bg-bottom.png" alt>
      </div>
    </div>
    <Footer :active="4" />
  </div>
</template>
<script>
import { Toast } from '@nutui/nutui'
import { getSinglepage } from '@/api/Comm/index'
import Header from '@/components/Header/Index'
import Footer from '@/components/Footer/Index'

export default {
  name: 'RuleMoney',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      tabIndex: 0,
      alliance: {
        code: 'Alliance',
        title: '',
        content: ''
      },
      salesMan: {
        code: 'SalesMan',
        title: '',
        content: ''
      }
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    initPage() {
      getSinglepage(this.alliance.code).then(res => {
        if (res && res.success) {
          this.alliance.title = res.data.title
          this.alliance.content = this.$resImg(res.data.content)
        } else {
          Toast.fail(res.msg)
        }
      })
      getSinglepage(this.salesMan.code).then(res => {
        if (res && res.success) {
          this.salesMan.title = res.data.title
          this.salesMan.content = this.$resImg(res.data.content)
        } else {
          Toast.fail(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .nut-button {
  background: #eea105;
  font-size: 14px;
}

.content {
  width: 100vw;
  min-height: 0;
  height: auto;
  overflow: hidden;
  box-sizing: border-box;
  padding: 20px 0 80px 0;

  .rule-wrap {
    .tab-head {
      width: 100%;
      height: 40px;
      position: relative;
      overflow: hidden;
      display: flex;
      justify-content: space-around;
      box-sizing: border-box;
      padding: 0 20px;

      input {
        width: 130px;
        height: 40px;
        line-height: 40px;
        appearance: none;
        border-radius: 5px;
        font-size: 17px;
        border: none;
        font-weight: 600;
        -webkit-appearance: none;
        background: #e6e6e6;
        color: #333333;
      }

      .btnSalesman.active,
      .btnFranchisee.active {
        color: #ffffff;
        background: #f7c926;
        background: #f2a511;
        background: -moz-linear-gradient(left, #f2a511 0%, #f7c926 100%);
        background: -webkit-gradient(
          linear,
          left right,
          left right,
          color-stop(0%, #f2a511),
          color-stop(100%, #f7c926)
        );
        background: -webkit-linear-gradient(left, #f2a511 0%, #f7c926 100%);
        background: -o-linear-gradient(left, #f2a511 0%, #f7c926 100%);
        background: -ms-linear-gradient(left, #f2a511 0%, #f7c926 100%);
        background: linear-gradient(to right, #f2a511 0%, #f7c926 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f2a511', endColorstr='#f7c926', GradientType=0);
      }
    }

    .tab-body {
      width: 100%;
      min-height: 0;
      height: auto;
      overflow: hidden;
      margin-top: 20px;
      box-sizing: border-box;
      padding: 0 20px;

      .tab {
        width: 100%;
        min-height: 20px;
        height: auto;
        overflow: hidden;
        box-sizing: border-box;
        border: 5px solid #b88c61;
        padding: 8px;
        background: right -20px / 50% no-repeat url('~@/assets/images/rule-bg-top.png');

        .tab-frame {
          width: 100%;
          overflow: hidden;
          box-sizing: border-box;
          border: 2px solid #b88c61;

          h4 {
            margin: 0;
            padding: 0;
            text-align: center;
            line-height: 30px;
          }

          .txt {
            width: 100%;
            box-sizing: border-box;
            margin: 0;
            padding: 0;

            img {
              max-width: 100%;
            }

            p {
              img {
                max-width: 100%;
              }
            }
          }
        }

        .title {
          text-align: center;
          font-size: 14px;
          color: #4c4c4c;
        }
      }
    }

    .img-wrap-bottom {
      width: 100%;
      height: 15px;

      img {
        position: relative;
        top: -275px;
        max-width: 100%;
      }
    }
  }
}
</style>
